import { render } from "./ContentRender.vue?vue&type=template&id=bdf3d6ee&scoped=true"
import script from "./ContentRender.vue?vue&type=script&lang=js"
export * from "./ContentRender.vue?vue&type=script&lang=js"

import "./ContentRender.vue?vue&type=style&index=0&id=bdf3d6ee&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdf3d6ee"]])

export default __exports__